export default __webpack_public_path__ + "static/media/forest.20104115.mp3";